import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Header from "./components/Header";
import Artists from "./components/Artists";
import Footer from "./components/Footer";

import Calum from "./pages/Calum.js";
import Blinded from "./pages/Blinded.js";
import Aili from "./pages/Aili.js";
import Dualities from "./pages/Dualities.js";

import "./App.css";

function App() {
  return (
    <Router>
      <div>
        <Header />

        <Switch>
          <Route exact path="/">
            <Artists />
          </Route>

          <Route path="/blindedhearts">
            <Blinded />
            <h1></h1>
          </Route>

          <Route path="/aili">
            <Aili />
          </Route>

          <Route path="/dualities">
            <Dualities />
          </Route>

          <Route path="/calumvenice">
            <Calum />
          </Route>
        </Switch>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
